import { FilterType } from "../../../typescript/Enums";
import Helper from "../../../helpers/Helper";
import FilterOption from "../../../types/instance/FilterOption";
import { INSTANCE_TYPE_ORACLE, INSTANCE_TYPE_SQLSERVER } from "../../Constants";
import ConditionalRender from "../../../helpers/ConditionalRender";
import { useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";


function ActivityTabs(props: {
    instanceType: string,
    waitsLength: number,
    clientsLength: number,
    databasesLength: number,
    schemasLength: number,
    sessionsLength: number,
    usersLength: number,
    osUsersLength: number,
    programsLength: number,
    statementsLength: number,
    batchesLength: number,
    isGroup: boolean,
    setCurrentTab: Function,
    filterOptions: FilterOption[]
}) {
    const {
        instanceType,
        waitsLength,
        databasesLength,
        schemasLength,
        sessionsLength,
        clientsLength,
        usersLength,
        osUsersLength,
        programsLength,
        statementsLength,
        batchesLength,
        setCurrentTab,
        isGroup
    } = props
    const navigate = useNavigate();
    const location = useLocation();

    const badgeStyle = (filterType: FilterType): string => {
        // TODO Find out why the options array becomes empty...
        return filterType < props.filterOptions.length &&
        props.filterOptions[filterType].filters.length > 0 ? "badge bg-filter" : "badge bg-info";
    }

    const { instanceId } = useParams();

    // Reset tabs to the first tab (e.g., Statements)
    useEffect(() => {
        const tabsContainer = document.getElementById('menu-inner');
        if (tabsContainer) {
            const batchesTab = (location.state as { groupedViewTab?: string } | null)?.groupedViewTab === 'batches'
                    ? tabsContainer.querySelector<HTMLAnchorElement>(isGroup ? '#groupedbatches-tab' : '#batches-tab')
                    : null;
            const firstTab = tabsContainer.querySelector<HTMLAnchorElement>(
                    'a[data-bs-toggle="tab"]'
            );
            (batchesTab || firstTab)?.click();
        }
    }, [instanceId]);

    const handleTabClick = (tabName: string) => (e: any) => {
        setCurrentTab(tabName)
        e.preventDefault();
        const params = new URLSearchParams(location.search);
        params.delete('filter'); // Remove the filter parameter

        // Update the URL with the modified params
        navigate({
            pathname: location.pathname,
            search: params.toString(), // This will update the URL without a page reload
        });
    };

    return (
            <div id="menu-inner" className="col nav nav-tabs menu-top" role="tablist">
                <ConditionalRender if={!isGroup}>
                    <a id="statements-tab" data-bs-toggle="tab" href="#statements" className="active"
                       role="tab"
                       aria-controls="statements" aria-selected="true">Statements
                        <span className="badge bg-info"
                              data-tooltip-id="global-tooltip" data-tooltip-content="Total statement count">{Helper.getFormattedBadgeCount(statementsLength)}</span></a>
                </ConditionalRender>
                <ConditionalRender if={!isGroup && instanceType === INSTANCE_TYPE_SQLSERVER}>
                    <a id="batches-tab" data-bs-toggle="tab" href="#batches" role="tab" onClick={handleTabClick('Batches')}
                       aria-controls="batches" aria-selected="true">Batches
                        <span className="badge bg-info"
                              data-tooltip-id="global-tooltip" data-tooltip-content="Total batches count">{Helper.getFormattedBadgeCount(batchesLength)}</span></a>
                </ConditionalRender>
                <ConditionalRender if={isGroup}>
                    <a id="statements-tab" data-bs-toggle="tab" href="#groupedstatements" className="active"
                       role="tab"
                       aria-controls="statements" aria-selected="true">Grouped Statements
                        <span className="badge bg-info"
                              data-tooltip-id="global-tooltip" data-tooltip-content="Total statement count">{Helper.getFormattedBadgeCount(statementsLength)}</span></a>
                </ConditionalRender>
                <ConditionalRender if={isGroup && instanceType === INSTANCE_TYPE_SQLSERVER}>
                    <a id="groupedbatches-tab" data-bs-toggle="tab" href="#groupedbatches" role="tab" onClick={handleTabClick('Gr Batches')}
                       aria-controls="groupedbatches" aria-selected="true">Grouped Batches <span className="badge bg-info"
                                                                                                 data-tooltip-id="global-tooltip" data-tooltip-content="Total batches count">{Helper.getFormattedBadgeCount(batchesLength)}</span></a>

                </ConditionalRender>
                <a id="waits-tab" data-bs-toggle="tab" href="#waits" role="tab" aria-controls="waits" onClick={handleTabClick('Waits')}
                   aria-selected="true">Waits
                    <span className={badgeStyle(FilterType.Waits)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total wait state count">{Helper.getFormattedBadgeCount(waitsLength)}</span></a>
                <a id="databases-tab" data-bs-toggle="tab" href="#databases" role="tab" onClick={handleTabClick('Databases')}
                   aria-controls="databases"
                   aria-selected="true">Databases
                    <span className={badgeStyle(FilterType.Databases)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total database count">{Helper.getFormattedBadgeCount(databasesLength)}</span></a>
                <ConditionalRender if={instanceType === INSTANCE_TYPE_ORACLE}>
                    <a id="schemas-tab" data-bs-toggle="tab" href="#schemas" role="tab" onClick={handleTabClick('Schemas')}
                       aria-controls="schemas" aria-selected="true">Schemas
                        <span className={badgeStyle(FilterType.Schemas)}
                              data-tooltip-id="global-tooltip" data-tooltip-content="Total schema count">{Helper.getFormattedBadgeCount(schemasLength)}</span></a>
                </ConditionalRender>
                <a id="sessions-tab" data-bs-toggle="tab" href="#sessions" role="tab" onClick={handleTabClick('Sessions')}
                   aria-controls="sessions" aria-selected="true">Sessions
                    <span className={badgeStyle(FilterType.Sessions)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total session count">{Helper.getFormattedBadgeCount(sessionsLength)}</span></a>

                <a id="clients-tab" data-bs-toggle="tab" href="#clients" role="tab" onClick={handleTabClick('Clients')}
                   aria-controls="clients"
                   aria-selected="true">Clients
                    <span className={badgeStyle(FilterType.Clients)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total client count">{Helper.getFormattedBadgeCount(clientsLength)}</span></a>
                <a id="users-tab" data-bs-toggle="tab" href="#users" role="tab" aria-controls="users" onClick={handleTabClick('Users')}
                   aria-selected="true">Users
                    <span className={badgeStyle(FilterType.Users)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total user count">{Helper.getFormattedBadgeCount(usersLength)}</span></a>
                <ConditionalRender if={instanceType === INSTANCE_TYPE_ORACLE}>
                    <a id="osusers-tab" data-bs-toggle="tab" href="#osusers" role="tab" onClick={handleTabClick('OS Users')}
                       aria-controls="osusers" aria-selected="true">OS Users
                        <span className={badgeStyle(FilterType.OsUsers)}
                              data-tooltip-id="global-tooltip" data-tooltip-content="Total OS user count">{Helper.getFormattedBadgeCount(osUsersLength)}</span></a>
                </ConditionalRender>
                <a id="programs-tab" data-bs-toggle="tab" href="#programs" role="tab" onClick={handleTabClick('Programs')}
                   aria-controls="programs" aria-selected="true">Programs
                    <span className={badgeStyle(FilterType.Programs)}
                          data-tooltip-id="global-tooltip" data-tooltip-content="Total program count">{Helper.getFormattedBadgeCount(programsLength)}</span></a>
            </div>
    );
}

export default ActivityTabs;
